import { nanoid } from 'nanoid'
import { TRACKING_ID_COOKIE_NAME, ORIGIN_PLATFORM_COOKIE_NAME, DEFAULT_PLATFORM } from '@/constants'

export function getCookieByName (name) {
  const cookies = document.cookie.split(';').reduce((acc, cur) => {
    const [key, value] = cur.trim().split('=')
    acc[key] = value
    return acc
  }, {})
  return cookies[name]
}

function writeCookie (name, value, options = {}) {
  // Validate required parameters
  if (!name || typeof name !== 'string') {
    throw new Error('Cookie name is required and must be a string')
  }

  if (value === undefined || value === null) {
    throw new Error('Cookie value is required')
  }

  let cookieString = `${encodeURIComponent(name)}=${encodeURIComponent(value)}`

  if (options.maxAge && typeof options.maxAge === 'number') {
    cookieString += `; max-age=${options.maxAge}`
  }

  // Set path (default to '/')
  const path = options.path || '/'
  cookieString += `; path=${path}`

  // Set domain if specified
  if (options.domain) {
    cookieString += `; domain=${options.domain}`
  }

  // Set secure flag if specified
  if (options.secure) {
    cookieString += '; secure'
  }

  // Set SameSite attribute if specified
  if (options.sameSite) {
    const validSameSiteValues = ['Strict', 'Lax', 'None']
    if (validSameSiteValues.includes(options.sameSite)) {
      cookieString += `; samesite=${options.sameSite}`
    } else {
      // eslint-disable-next-line no-console
      console.warn('Invalid SameSite value. Use "Strict", "Lax", or "None"')
    }
  }

  // Set the cookie
  document.cookie = cookieString

  return true
}

export function setCookie (cookieName, cookieValue) {
  writeCookie(cookieName, cookieValue, {
    maxAge: 60 * 60 * 24 * 365, // 1 year
    domain: process.env.VUE_APP_COOKIE_DOMAIN,
    sameSite: 'None',
    secure: true
  })
}

export function handleTrackingCookies () {
  // TRACKING ID
  const tidCookie = getCookieByName(TRACKING_ID_COOKIE_NAME)
  if (!tidCookie) {
    setCookie(TRACKING_ID_COOKIE_NAME, nanoid())
  }

  // ORIGIN PLATFORM
  const originPlatformCookie = getCookieByName(ORIGIN_PLATFORM_COOKIE_NAME)
  if (!originPlatformCookie) {
    setCookie(ORIGIN_PLATFORM_COOKIE_NAME, DEFAULT_PLATFORM)
  }
}
